module.exports = __webpack_public_path__ + "493f9a7941f14f47782d1de1dcbf941e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/five-menu.png
// module id = 1071
// module chunks = 0